import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export const deleteMe =
  withNextApi<BackendResponse>(
    "/cvp/CvpDeleteMe",
    { method: "DELETE" }
  );
  